import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import { EPPAStep } from 'types/ppaOnboarding';
import { EInvitedProviderStep } from 'pages/InvitedProviderOnboarding/steps';

// 「提交前就已经是 Klarity 用户」——原型 submit 页 Account 轴的 Already on Klarity。
// 这类用户已经有 EHR、已经在 marketplace 上，所以提交成功页不再推销：
// 只留确认区 / Track / What happens next（缺 fax 时仍给 fax 卡）。
//
// 后端目前没有显式字段，用 HomeInfo 上的 marketplace 上线信号代理判断。
// 若后续 credentialing overview 返回显式标志位，改这一个函数即可。
const useIsExistingKlarityUser = (): [boolean, boolean] => {
    const [homeInfo, loading] = useProviderHomeInfo();
    const isExisting = !!(
        homeInfo?.klarityListed ||
        homeInfo?.completedOnboarding ||
        homeInfo?.klarityOnboardingStep === EPPAStep.STEP_21 ||
        homeInfo?.klarityOnboardingStep === EInvitedProviderStep.COMPLETED
    );
    return [isExisting, loading];
};

export default useIsExistingKlarityUser;
